export default {
  namespaced: true,
  state() {
    return {
      rankTotal: 0,
      currentRank: null,
      currentLesson: null,
      pdfUrl: '',
      htmlContent: '',
      articleTitle: '',
      articleAuthor: '',
      articleImage: '',
      articleId: '',
      articleLevel: '',
      pdfZoom: 100,
      pdfHeight: 165,
      lessonCount: 0,
      htmlZoom: 100,
      htmlHeight: 165,
      fontSize: 14,
      lineHeight: 36,
      levelBgWidth: 108,
      levelFontSize: 13,
      htmlTitleSize: 18,
      currentRanks: [],
      currentLessons: [],
      showMaterialControl: false,
      showVocabularyBook: false,
      showPDFHtml: false,
      isFetchingMaterial: false,
      pdfHtmlZoom: 1.0,
      isLevel0: false,
      showPDFMaterial: false,
      showMaterial: false
    };
  },
  mutations: {
    /**
     * Set Rank Level
     *
     * @param {*} state
     * @param {*} payload
     */
    setRankTotal(state, payload) {
      state.rankTotal = payload;
    },
    /**
     * Set the Current Rank Program
     *
     * @param {*} state
     * @param {*} payload
     */
    setCurrentRank(state, payload) {
      state.currentRank = payload;
    },
    /**
     * Set the Current Lesson
     *
     * @param {*} state
     * @param {*} payload
     */
    setCurrentLesson(state, payload) {
      state.currentLesson = payload;
    },
    /**
     * Switch and Set Next Lesson as Current Lesson
     *
     * @param {*} state
     */
    nextLesson(state) {
      if (state.rankTotal >= state.currentRank && state.currentLesson < state.lessonCount) {
        state.currentLesson++;
      } else if (state.rankTotal > state.currentRank) {
        state.currentRank++;
        state.currentLesson = 0;
      }
    },
    /**
     * Switch and Set Previous Lesson as Current Lesson
     *
     * @param {*} state
     */
    previousLesson(state) {
      if (state.currentRank >= 0 && state.currentLesson > 0) {
        state.currentLesson--;
      } else if (state.currentRank != 0) {
        state.currentRank--;
        state.currentLesson = state.lessonCount;
      }
    },
    /**
     * Set the PDF Url
     *
     * @param {*} state
     * @param {*} payload
     */
    setPdfUrl(state, payload) {
      state.pdfUrl = payload;
    },
    /**
     * Set Material Lesson Count
     *
     * @param {*} state
     * @param {*} payload
     */
    setLessonCount(state, payload) {
      state.lessonCount = payload;
    },
    /**
     * Set the Html Content
     *
     * @param {*} state
     * @param {*} payload
     */
    setHtmlContent(state, payload) {
      state.htmlContent = payload.content;
      state.articleAuthor = payload.author;
      state.articleTitle = payload.title;
      state.articleImage = payload.image_url;
      state.articleId = payload.id;
      state.articleLevel = payload.recommended_level;
    },
    /**
     * PDF Zoom In
     *
     * @param {*} state
     */
    pdfZoomIn(state) {
      if (state.pdfZoom === 200) {
        return;
      }

      state.pdfHeight += 35;
      state.pdfZoom += 20;
    },
    /**
     * PDF Zoom Out
     *
     * @param {*} state
     */
    pdfZoomOut(state) {
      if (state.pdfZoom === 100) {
        return;
      }

      state.pdfZoom -= 20;
      state.pdfHeight -= 35;
    },
    /**
     * HTML Zoom In
     *
     * @param {*} state
     */
    htmlZoomIn(state) {
      if (state.htmlZoom === 200) {
        return;
      }

      state.htmlZoom += 20;
      state.htmlHeight += 35;
      state.fontSize += 2;
      state.lineHeight += 2;
      state.levelFontSize += 2;
      state.htmlTitleSize += 2;
      state.articleIdSize += 2;
      state.articleSlashSize += 2;
      state.levelBgWidth += 10;
    },
    /**
     * HTML Zoom Out
     *
     * @param {*} state
     */
    htmlZoomOut(state) {
      if (state.htmlZoom === 100) {
        return;
      }

      state.htmlZoom -= 20;
      state.htmlHeight -= 35;
      state.fontSize -= 2;
      state.lineHeight -= 2;
      state.levelFontSize -= 2;
      state.htmlTitleSize -= 2;
      state.levelBgWidth -= 10;
    },
    /**
     * PDF Reset Zoom
     * 
     * @param {*} state
     */
    resetPdfZoom(state) {
      state.pdfZoom = 100;
    },
    /**
     * Set Current rank of selected lesson
     *
     * @param {*} state
     * @param {*} payload
     */
    setCurrentRanks(state, payload) {
      state.currentRanks = payload;
      state.isLevel0 = (!payload.lv && payload.rk > 0);
    },
    setCurrentLessons(state, payload) {
      state.currentLessons = payload;
    },
    setShowMaterialControl(state, show) {
      state.showMaterialControl = show;
    },
    setShowVocabularyBook(state, payload) {
      state.showVocabularyBook = payload;
    },
    /**
     * Set flag when fetching/loading material
     *
     * @param {*} state
     * @param {*} payload
     */
    setIsFetchingMaterial(state, payload) {
      state.isFetchingMaterial = payload;
    },
    /**
     * Set PDF HTML component display based on HTML material existence
     *
     * @param {*} state
     * @param {*} payload
     */
    showHtmlContent(state, payload) {
      state.showPDFHtml = payload;
    },

    setShowPDFMaterial(state, payload) {
      state.showPDFMaterial = payload;
    },

    pdfHtmlZoomIn(state) {
      if (parseFloat(state.pdfHtmlZoom).toFixed(1) == 1.5) {
        return;
      }

      state.pdfHtmlZoom += 0.1;
    },
    pdfHtmlZoomOut(state) {
      if (parseFloat(state.pdfHtmlZoom).toFixed(1) == 1.0) {
        return;
      }

      state.pdfHtmlZoom -= 0.1;
    },
    setShowMaterial(state, payload) {
      state.showMaterial = payload;
    }
  },
  getters: {
    articleLevels: state => {
      const RECOMMENDED_LEVEL = {
        1: '1',
        2: '2-3',
        3: '4-5',
      };
      return RECOMMENDED_LEVEL[state.articleLevel];
    },
  }
};
